"use client";

import { MapPin, Star } from "lucide-react";
import Image from "next/image";
import { useEffect, useState, type CSSProperties } from "react";

const asm = (ms: number) => ({ "--asm-delay": `${ms}ms` }) as CSSProperties;
const star = (ms: number) => ({ "--star-delay": `${ms}ms` }) as CSSProperties;

export function HeroProfileCard() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const start = () => setReady(true);

    if (typeof window.requestIdleCallback === "function") {
      const id = window.requestIdleCallback(start, { timeout: 300 });
      return () => window.cancelIdleCallback(id);
    }

    const timer = window.setTimeout(start, 0);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      className="profile-card"
      data-ready={ready ? "true" : "false"}
      role="img"
      aria-label="Hotový profil firmy na Firmy.cz: fotografie provozovny, název VAŠE FIRMA s.r.o., hodnocení pěti hvězdami a 128 hodnocení, adresa s označením Otevřeno a tlačítko Navigovat."
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-ink-900">
        <Image
          src="/uploads/card.jpg"
          alt=""
          fill
          sizes="(min-width: 1024px) 300px, 80vw"
          className="grayscale-photo object-cover"
          data-asm=""
          style={asm(0)}
        />
      </div>

      <div className="mt-4">
        <p
          className="text-base font-bold tracking-tight text-white"
          data-asm=""
          style={asm(90)}
        >
          VAŠE FIRMA s.r.o.
        </p>

        <div className="mt-2 flex items-center gap-2">
          <span className="flex items-center gap-0.5" data-asm="" style={asm(180)}>
            {[0, 1, 2, 3, 4].map((index) => (
              <Star
                key={index}
                className="h-4 w-4 text-blue"
                fill="currentColor"
                strokeWidth={1.25}
                data-star=""
                style={star(900 + index * 160)}
                aria-hidden="true"
              />
            ))}
          </span>
          <span
            className="overline text-[10px] text-slate-muted"
            data-asm=""
            style={asm(270)}
          >
            128 HODNOCENÍ
          </span>
        </div>
      </div>

      <div
        className="my-4 h-px w-full bg-hairline-dark"
        data-frame-line=""
        style={asm(520)}
        aria-hidden="true"
      />

      <div
        className="flex items-center justify-between gap-3"
        data-asm=""
        style={asm(360)}
      >
        <span className="text-sm text-white/90">Vaše ulice 12, Praha</span>
        <span className="overline text-[10px] text-slate-muted">OTEVŘENO</span>
      </div>

      <div
        className="my-4 h-px w-full bg-hairline-dark"
        data-frame-line=""
        style={asm(620)}
        aria-hidden="true"
      />

      <div
        className="inline-flex items-center gap-2 bg-blue px-3 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-white"
        data-asm=""
        style={asm(450)}
      >
        <MapPin className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" />
        NAVIGOVAT
      </div>
    </div>
  );
}
